import CodeHighlighter from './CodeHighlighter';
import type { CodeHighlighterProps } from './interface';

export type { CodeHighlighterProps };
export default CodeHighlighter;
